// TimeGridWeek — вид «Неделя» (M2): заголовки дней (Пн..Вс), all-day ряд (M5) и 7 колонок с общей осью.
// Заголовки — канон MonthGrid (WEEKDAY_LABELS); даты — format с { locale: ru } (B3).
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import type { CalendarEvent } from '@/api/calendar';
import { TimeGrid, TIME_AXIS_WIDTH_PX } from './TimeGrid';
import { AllDayRow } from './AllDayRow';

interface TimeGridWeekProps {
  /** Локальные дни недели (Пн–Вс) — колонки. */
  days: Date[];
  /** События диапазона недели (allDay — в AllDayRow, timed — в TimeGrid). */
  events: CalendarEvent[];
  /** Колбэк клика по событию (переход к detail). */
  onEventClick?: ((event: CalendarEvent) => void) | undefined;
}

/** Подписи дней недели (канон MonthGrid: массив, понедельник первым). */
const WEEKDAY_LABELS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

/** Заголовок дня: «Пн» (getDay: 0=Вс, 1=Пн → сдвиг массива в понедельник-первую ось). */
function dayLabel(day: Date): string {
  return WEEKDAY_LABELS[(day.getDay() + 6) % 7] as string;
}

/** Вид «Неделя»: заголовки дней + all-day ряд + TimeGrid с 7 колонками. */
export function TimeGridWeek({ days, events, onEventClick }: TimeGridWeekProps): JSX.Element {
  return (
    <Box>
      <Box data-testid="week-day-headers" sx={{ display: 'flex', ml: TIME_AXIS_WIDTH_PX, mb: 0.5 }}>
        {days.map((day, dayIndex) => (
          <Box key={dayIndex} data-testid={`day-header-${dayIndex}`} sx={{ flex: 1, textAlign: 'center' }}>
            <Typography variant="caption" sx={{ fontWeight: 600 }}>
              {dayLabel(day)}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
              {format(day, 'd', { locale: ru })}
            </Typography>
          </Box>
        ))}
      </Box>
      <AllDayRow days={days} events={events} onEventClick={onEventClick} />
      <TimeGrid days={days} events={events} onEventClick={onEventClick} />
    </Box>
  );
}
